import React from 'react';
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

import { PagesBanner } from '../'
import './Partners.sass'


function renderEntry(entries) {
  return entries.map((entry, idx) =>
    <div className="partners-entry" key={idx}>
      <div className="partners-entry-content">
        <p className="page__content-p-header">{entry.name}</p>
        <span className="cms__content markdown-bullet-list" dangerouslySetInnerHTML={{__html: entry.description}} />
      </div>
      { entry.url ?
        <a
          href={entry.url}
          rel="noopener noreferrer"
          target="_blank"
          className="partners-entry-img"
        >
          <img src={entry.photo} alt={`${entry.name}`} />
        </a> :
        <div className="partners-entry-img">
          <img src={entry.photo} alt={`${entry.name}`} />
        </div>
      }

    </div>
  )
}


const Partners = ({ contentData, bgClassName }) => {
  return (
    <div className="page__wrapper partners-page">
      <Helmet>
        <title>{contentData.title} | Gulf TREE</title>
      </Helmet>
      <PagesBanner bgClassName={bgClassName} title={contentData.title} />
      <section className="page__content partners-content">
        <div className="page__content-section">
          <h2>Partner Organizations</h2>
          {renderEntry(contentData.partner_organizations)}
        </div>
        <div className="page__content-section">
          <h2>Project Team</h2>
          {renderEntry(contentData.project_team)}
        </div>
      </section>
    </div>
  )
}

Partners.propTypes = {
  contentData: PropTypes.shape({
    partner_organizations: PropTypes.array.isRequired,
    project_team: PropTypes.array.isRequired,
    title: PropTypes.string
  }),
  bgClassName: PropTypes.string
}

export default Partners
